module.exports = __webpack_public_path__ + "static/media/animal-shelter.41060e44.svg";